import { chakra, Text } from '@chakra-ui/react';
import useCurrencyText from 'hooks/shared/useCurrencyText';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';

interface Props {
  profitAmount: number;
  profitPercent: number;
  currency: Currency;
  isFilled?: boolean;
  style?: 'dot' | 'round-brackets';
}

const ProfitText: FC<Props> = ({
  profitAmount,
  profitPercent,
  currency,
  isFilled = false,
  style = 'round-brackets',
  ...props
}) => {
  const currencyFormatter = useCurrencyText();

  const sign = profitAmount === 0 ? '' : profitAmount > 0 ? '+' : '';
  let text;
  if (style === 'dot') {
    text = `${sign}${currencyFormatter(profitAmount, {
      symbol: currency.symbol,
    })} · ${profitPercent.toFixed(2)}%`;
  } else if (style === 'round-brackets') {
    text = `${sign}${currencyFormatter(profitAmount, {
      symbol: currency.symbol,
    })} (${profitPercent.toFixed(2)}%)`;
  }

  if (isFilled) {
    const bgColor = profitAmount >= 0 ? Color.Profit : Color.Loss;

    return (
      <div>
        <Text
          color="#fff"
          bgColor={bgColor}
          px="8px"
          py="6px"
          borderRadius="18px"
          display="inline-block"
          {...props}
        >
          {text}
        </Text>
      </div>
    );
  } else {
    const color =
      profitAmount === 0
        ? Color.OnSurface
        : profitAmount > 0
        ? Color.Profit
        : Color.Loss;

    return (
      <Text color={color} {...props}>
        {text}
      </Text>
    );
  }
};

export default chakra(ProfitText);
